module.exports = __webpack_public_path__ + "img/logo-tauli.bf80ac5d.png";